import Model from "./base/model";

class QuotationLog extends Model{
  resourceName() {
    return "quotation_logs";
  }

  fields() {
    return {
      text: "",
      created_at: "",
      company: { jsonApi: "hasOne", type: "companies"},
      user: { jsonApi: "hasOne", type: "users"},
    }
  }
}

export default new QuotationLog();
